import { render, staticRenderFns } from "./gc-dashboard-product-history-card.vue?vue&type=template&id=8f946400&scoped=true"
import script from "./gc-dashboard-product-history-card.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-product-history-card.vue?vue&type=script&lang=js"
import style0 from "./gc-dashboard-product-history-card.vue?vue&type=style&index=0&id=8f946400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f946400",
  null
  
)

export default component.exports